import React, { Component } from 'react';
import { Redirect, withRouter, Link, Route, useLocation } from 'react-router-dom';
import { withOktaAuth } from '@okta/okta-react';
import OktaAuth from '@okta/okta-auth-js';

import pkceChallenge from 'pkce-challenge';
import WithTracker from './../../../../containers/App/WithTracker';

import FreeAccount from './../../payment/PricingCards/components/FreeAccount';

import TopBar from './../../TopBar'
import Footer from './../../Footer'
import { _axiosCall } from '../../../helpers/apicalls';
import axios from "axios";
import {
  Card, CardBody, Row, Col, Nav, NavLink, NavItem, TabContent, TabPane, Container, Badge, Collapse
} from 'reactstrap';
import{
	setLocalStorage,
	getLocalStorage
} from '../../../helpers/utils';

import{
	_getUserSSO,
	_setSSOToken,
	_getSSOToken,
	decodeIdToken
} from './ssoutils';
import { Publisher } from "./../../../pubsub/publisher.js";

function replaceDomainWithCurrent(url) {
  const originalUrl = new URL(url);
  
  // Get the current domain from the window location
  const currentDomain = window.location.hostname;
  
  // Replace the original URL's hostname (domain) with the current domain
  originalUrl.hostname = currentDomain;
  return originalUrl.href;
}


export default withRouter(class Login extends Component {
  constructor(props) {
	super(props);
	this.onSuccess = this.onSuccess.bind(this);
	this.onError = this.onError.bind(this);
	this.state = {
	  authenticated: null,
	  fetchInProgress: false,
	  authToken: false,
	  error: false,
	  errorMessage:false
	};

  }
  
  componentDidMount() {
	   if(window.location.href.indexOf('redirect')<0){
		   const codes = pkceChallenge();
		   sessionStorage.setItem('code_challenge', codes.code_challenge);
		   sessionStorage.setItem('code_verifier', codes.code_verifier);
		   const AUTH_URL = `${process.env.MP_BASE_URL}authorize?client_id=${process.env.MP_CLIENT_ID}&code_challenge=${codes.code_challenge}&code_challenge_method=S256&redirect_uri=${replaceDomainWithCurrent(process.env.MP_REDIRECT_URI)}&response_mode=fragment&response_type=code&state=testing&scope=openid email profile`;
		   window.location.href = AUTH_URL;
		   
		   
	   }else if(window.location.href.indexOf('redirect')>=0){   
		   var hash = window.location.hash.substr(1);
		   
		   var hashObject = hash.split('&').reduce(function (res, item) {
			   var parts = item.split('=');
			   res[parts[0]] = parts[1];
			   return res;
		   }, {});
		   
		   console.log(hashObject);
		   if(hashObject['error']){
				this.setState({error:hashObject['error'], errorMessage: hashObject['error_description'] ? decodeURI(hashObject['error_description'].replace(/\+/g, " ")) : "Authorization failed, please contact your support team."})
			  }else{
				  this._getAuthToken(hashObject)
			   }
	   }
  }
  
  _getAuthToken = (hashObject) => {
	   // console.log('_getBuildingData called', this.state)
	   if (!this.state.fetchInProgress) {
			this.setState(prevState => ({ fetchInProgress: true, }));
		}
		
		const params = new URLSearchParams();
		params.append('client_id', process.env.MP_CLIENT_ID);
		params.append('redirect_uri', replaceDomainWithCurrent(process.env.MP_REDIRECT_URI));
		params.append('grant_type', "authorization_code");
		params.append('code', hashObject.code);
		params.append('code_verifier', sessionStorage.getItem('code_verifier'));
		axios.post(`${process.env.MP_BASE_URL}token`, params).then(token => {
			
			
			if(token.data && token.data.id_token){
				const decodedClaims = decodeIdToken(token.data.id_token);
				_setSSOToken(token.data, 'MPSSO');
				
				// token.data.claims = {
				// 	"aud" : "b8a4bfd0-3ab6-4dc8-836f-4144e7b9dbbf",
				// 	"iss" : "https://login.microsoftonline.com/36e9c86e-2c1d-4374-ba31-c4b88acabce1/v2.0",
				// 	"iat" : 1748377718,
				// 	"nbf" : 1748377718,
				// 	"exp" : 1748381618,
				// 	"email" : "rferrari@elliman.com",
				// 	"name" : "Ferrari, Richard",
				// 	"oid" : "66e81073-b504-4163-af4d-89a126baf55b",
				// 	"preferred_username" : "RFERRARI@elliman.com",
				// 	"rh" : "1.AQQAbsjpNh0sdEO6McS4isq84dC_pLi2OshNg29BROe5278EAfcEAA.",
				// 	"sid" : "004f3959-09d1-37cc-d7de-6d718a221b11",
				// 	"sub" : "RFOWycJYossVWB10u29Q9z42DWrQ8ZFai9OELb0Ne3M",
				// 	"tid" : "36e9c86e-2c1d-4374-ba31-c4b88acabce1",
				// 	"uti" : "o07GhXgKKECsgOXqHrRIAA",
				// 	"ver" : "2.0"
				// };
				// _setSSOToken(token.data, 'ELLIMAN');
				
				console.log(token.data);
				Publisher.publish("track-mp.userLogin.ssoTokenClaims", {
					user: {
					  id: decodedClaims.sub,
					  ...decodedClaims
					},
					customData: token.data
				  });
				this.setState({authToken : token.data})
				
			}
			
			//console.log(this._oktaAuth)
				
		})
		.catch(error => {
			console.log("error: " + error);
		});
		
	
	}

 
  onSuccess(res) {
	if (res.status === 'SUCCESS') {
	  return this.props.authService.redirect({
		sessionToken: res.session.token
	  });
   } else {
	
	}
  }

  onError(err) {
	console.log('error logging in', err);
  }

  render() {
	const { location } = this.props;
	const { authToken, error, errorMessage } = this.state;
	console.log(authToken)
	if(authToken){
		return <Redirect to={{ pathname: `/`}} />
	}
	if(window.location.href.indexOf('sso')>=0 && !error) return null;
	const isError = error;
	return (
		<div className="plan__wrapper share__wrapper">
			
		</div>
	)
	
	  

		
  }
});